'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  isCollapsed = true;

  constructor(Auth, $state, $location, SettingsService) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.isSuperAdmin = Auth.isSuperAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$state = $state;
    this.$location = $location;

    SettingsService.getByName({name: 'client'}, settings => {
      this.useSuite = settings.data.useSuite;
      this.boardResolution = settings.data.boardResolution;

      var theme = settings.data.theme || 'spacelab';
      var backgroundUrl = settings.data.background ? '/api/storage/' + settings.data.background : '/assets/images/background.jpg';

      jQuery("body").css('background', 'url(' + backgroundUrl + ') no-repeat center center fixed');
      jQuery("body").css("-webkit-background-size", "cover");
      jQuery("body").css("-moz-background-size", "cover");
      jQuery("body").css("-o-background-size", "cover");
      jQuery("body").css("background-size", "cover");
      jQuery('head').append('<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootswatch/3.3.7/'+theme+'/bootstrap.min.css" type="text/css" />');

      SettingsService.getByName({name: 'config.app'}, settings => {
        let ssDT = settings.data.serverSideDT || {};
        this.serverSideDT = ssDT && ssDT.webaccess && ssDT.webaccess.enabled;

        this.menu = [{
          previewMode: true,
          title: 'My Votings',
          url: "/home"
        }, {
          previewMode: true,
          title: 'Calendar',
          url: "/calendar"
        }, {
          adminOnly: true,
          hideSuite: true,
          title: "Portfolio",
          subMenu: [{
            title: 'Properties',
            url: '/property/list'
          }, {
            title: 'Contacts',
            url: '/contact/list'
          }, {
            title: "Voter Groups",
            url: "/voter-group/list"
          }, {
            title: "E-Voting Access",
            url: (this.serverSideDT) ? "/webaccess/list/ss" : "/webaccess/list"
          }]
        }, {
          adminOnly: true,
          title: 'Votings',
          url: '/voting/list'
        }, {
          adminOnly: true,
          title: 'Admin',
          subMenu: [
            {
              title: 'Client Settings',
              url: '/admin/client/edit'
            },
            {
              title: 'User Management',
              url: '/admin/users'
            },
            {
              title: "Mails",
              url: '/mail/draft/list'
            },
            {
              title: "E-Forms",
              url: "/e-form/list"
            }, {
              title: "Letter Templates",
              url: "/template/list"
            }
          ]
        }];

        if (this.boardResolution) {
          this.menu[4].subMenu.push({
            "download": true,
            "title": "Board Resolution",
            "url": "/api/storage/" + this.boardResolution
          });
        }
      });

    });

    this.publicMenu = [];
  }

  permissionMenuEntry(menuEntry) {
    return !menuEntry.subMenu
      && menuEntry.url
      && (!menuEntry.adminOnly || (menuEntry.adminOnly && this.isAdmin() && !this.previewMode))
      && (!menuEntry.previewMode || (menuEntry.previewMode && !this.isAdmin()) || (menuEntry.previewMode && this.isAdmin() && this.previewMode))
  }

  permissionSubMenuEntry(menuEntry) {
    return menuEntry.subMenu
      && (!menuEntry.adminOnly || (menuEntry.adminOnly && this.isAdmin() && !this.previewMode))
  }

  isActive(routePart) {
    return this.$location.path().indexOf(routePart) !== -1;
  }

  communityChanged() {
    let cmty = this.communityEnum.find(cmty => cmty.value == this.ViewSelection.selectedCommunityCode);
    this.ViewSelection.selectedCommunity = cmty;
  }

  search(form) {
    this.searchSubmitted = true;

    if(form.$valid) {
      this.searchSubmitted = false;
      this.$state.go('search-result',{searchterm: this.searchterm});
    }
  }
}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js